import { httpsCallable } from 'firebase/functions';
import { functions } from '../../services/firebase';
import { rememberCareSourceActivityFromResult } from '../careSourceProcessing/careSourceSessionActivity';
import { CAPTURE_FIRST_AI_TIMEOUT_MS } from './captureFirstAiErrors';

const extractRawCareCaptureCallable = httpsCallable(
  functions,
  'extractRawCareCaptureWithAi',
  { timeout: CAPTURE_FIRST_AI_TIMEOUT_MS }
);

const captureAndOrganizeCareNoteCallable = httpsCallable(
  functions,
  'captureAndOrganizeCareNote',
  { timeout: CAPTURE_FIRST_AI_TIMEOUT_MS }
);

const captureCareSourceNoteCallable = httpsCallable(
  functions,
  'captureCareSourceNote',
  { timeout: 30000 }
);

const organizeCapturedCareSourceNoteCallable = httpsCallable(
  functions,
  'organizeCapturedCareSourceNote',
  { timeout: CAPTURE_FIRST_AI_TIMEOUT_MS }
);

export const runCaptureFirstExtraction = async ({ rawText = '', sourceType = 'unknown', options = {} } = {}) => {
  const response = await extractRawCareCaptureCallable({
    rawInput: {
      rawText,
      sourceType,
    },
    options,
  });

  return response.data;
};

export const captureAndOrganizeCareNote = async ({
  childId = '',
  rawText = '',
  sourceType = 'unknown',
  options = {},
} = {}) => {
  const response = await captureAndOrganizeCareNoteCallable({
    childId,
    rawText,
    sourceType,
    options,
  });

  rememberCareSourceActivityFromResult(response.data);

  return response.data;
};

export const captureCareSourceNote = async ({
  childId = '',
  rawText = '',
  sourceType = 'unknown',
} = {}) => {
  const response = await captureCareSourceNoteCallable({
    childId,
    rawText,
    sourceType,
  });

  rememberCareSourceActivityFromResult(response.data);

  return response.data;
};

export const organizeCapturedCareSourceNote = async ({
  sourceNoteId = '',
  options = {},
} = {}) => {
  const response = await organizeCapturedCareSourceNoteCallable({
    sourceNoteId,
    options,
  });

  return response.data;
};
